export default "__VITE_ASSET__DKbmifrV__"